
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n/index";
import moment from "moment";

export default defineComponent({
  name: "AbsenceDetails",
  props: ["courseAbsenceDetailsRes"],
  setup() {
    const { t, te } = useI18n();
    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    // Formate Date
    const formattedDate = (date) => {
      return moment(date).format("DD/MM/YYYY");
    };
    return {
      translate,
      formattedDate,
    };
  },
});
